<section class="container-fluid temp-color">
  <div class="row">
    <div class="col-sm-2">
      <security-navigation class="sticky-nav"> </security-navigation>
    </div>
    <div class="col-sm-10">
      <ng-container>
        <h1 id="main-title" class="page-title ng-binding">User Roles</h1>

        @if (dataSource) {
          <ng-template #headerTemplate>
            <div nfrpColumn [width]="15" widthType="%" [id]="'role-number-label'" defaultDirection="ASCENDING">
              User Role Id
              <nfrp-grid-sorter [column]="'tpAdminNbr'" dataType="string" (sort)="sort($event)"> </nfrp-grid-sorter>
            </div>
            <div nfrpColumn [width]="35" widthType="%" [id]="'role-name-label'">
              User Role Label
              <nfrp-grid-sorter [column]="'tpAdminLabel'" dataType="string" (sort)="sort($event)"> </nfrp-grid-sorter>
            </div>
            <div nfrpColumn [width]="15" widthType="%" [id]="'role-active-label'">
              Active
              <nfrp-grid-sorter [column]="'tpAdminActive'" dataType="string" (sort)="sort($event)"> </nfrp-grid-sorter>
            </div>
            <div nfrpColumn [width]="15" widthType="%" [id]="'role-nwadmin-label'">
              NWIE Visibility
              <nfrp-grid-sorter [column]="'tpAdminNWAdmin'" dataType="number" (sort)="sort($event)"> </nfrp-grid-sorter>
            </div>
          </ng-template>
          <ng-template #rowTemplate let-roleResult="item" let-index="index">
            <div>
              <div [id]="'role-number-' + index">
                <a class="text-decor-underline" (click)="userAdminRowClicked(roleResult)">{{ roleResult.userTypeId | nfrpNormalizeValue: '-' }}</a>
              </div>
              <div [id]="'role-label-' + index">
                <a class="text-decor-underline" (click)="userAdminRowClicked(roleResult)">{{ roleResult.userTypeLabel | nfrpNormalizeValue: '-' }}</a>
              </div>
              <div [id]="'role-active-' + index">
                {{ roleResult.typeActive === 1 ? 'Yes' : ('No' | nfrpNormalizeValue: '-') }}
              </div>
              <div [id]="'role-nwadmin-' + index">
                {{ roleResult.nwVisibility === 'Visible' ? 'Yes' : ('No' | nfrpNormalizeValue: '-') }}
              </div>
            </div>
          </ng-template>
          <nfrp-grid
            [headerTemplate]="headerTemplate"
            [rowTemplate]="rowTemplate"
            [iterable]="data"
            [width]="100"
            rowIdPrefix="tpadmin-details"
          ></nfrp-grid>
          <nfrp-grid-paginator
            (paginate)="paginate($event)"
            [numberOfItems]="numberOfItems"
            [itemsPerPageOptions]="[20, 50, 100]"
            [defaultItemsPerPage]="20"
          ></nfrp-grid-paginator>
        } @else {
          <nfrp-spinner></nfrp-spinner>
        }
      </ng-container>
    </div>
  </div>
</section>
<nfrp-navigate-away-modal></nfrp-navigate-away-modal>
